/**
 * Entry point for the DeepAgent embeddable widget bundle.
 *
 * Importing this module:
 *   • Registers `<deepagent-agent>` (and its nested elements) as custom elements
 *   • Is idempotent — multiple loads on the same page are a no-op
 *   • Has no side effects beyond custom element registration
 *
 * Built into `dist/embed.js` (IIFE) via Vite library mode and copied to
 * `apps/web/public/embed.js` by the web app's build step.
 */

import "./elements/deepagent-agent.js";

// Re-export the root element class so advanced integrators can extend it.
export { DeepAgentAgent } from "./elements/deepagent-agent.js";
export type { StartConversationOptions } from "./elements/deepagent-agent.js";
export { EmbedApiError } from "../../shared-types/src/utils/embed-dynamic-variables.js";

// Surface a tiny global namespace marker so customer sites can detect that
// the widget loaded (useful for analytics + smoke tests).
declare global {
  interface Window {
    DeepAgentEmbed?: { version: string };
  }
}

const VERSION = "0.1.1";
if (typeof window !== "undefined" && !window.DeepAgentEmbed) {
  window.DeepAgentEmbed = { version: VERSION };
}
